import { useEffect, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { GEARTEST_ROOM_JOIN } from "modules/systemCheck/constants";
import { useAppDispatch } from "store/hooks";
import { selectDailyResult } from "../../redux/selectors";
import { setDailyResult } from "../../redux/systemCheckSlice";
import { useGeartestDailyRoomJoin } from "../../hooks/useGeartestDailyRoomJoin";

export const DailyReachabilityTest = () => {
  const { isSuccessful, isLoading } = useGeartestDailyRoomJoin();
  const dispatch = useAppDispatch();
  const { isDirty } = useSelector(selectDailyResult);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isDirty) {
      queryClient.invalidateQueries({ queryKey: [GEARTEST_ROOM_JOIN] });
    }
  }, [isDirty, queryClient]);

  const reachabilityResult = useMemo(
    () => ({
      isLoading,
      isSuccessful,
      isDirty: false,
    }),
    [isSuccessful, isLoading],
  );

  useEffect(() => {
    dispatch(setDailyResult(reachabilityResult));
  }, [reachabilityResult, dispatch]);

  return null;
};
